import Vue from 'vue';

class EventBusInstance extends Vue 
{
}

export const EventBus = new EventBusInstance();